export default __webpack_public_path__ + "static/media/IMG_2495.1551dde6.jpg";